import classNames from 'classnames';
import * as React from 'react';
import {CSSProperties} from 'react';
import {FormattedMessage} from 'react-intl';

import styles from './LoadingSpinner.less';

interface OwnProps {
  isVisible?: boolean;
  text?: string;
  marginTop?: number;
  wrapperStyles?: CSSProperties;
}
type Props = OwnProps;

export const LoadingSpinner: React.FC<Props> = (props) => {
  const {isVisible = false, text = 'common.loading.text', marginTop = 75, wrapperStyles, ...extraProps} = props;
  return isVisible ? (
    <div className={styles.dlLoadingSpinnerWrapper} {...extraProps} style={wrapperStyles}>
      <div className={styles.dlLoadingSpinnerObject}>
        <div style={{width: '100%', height: 0, marginTop}} />
        <div
          className={classNames({
            'fas fa-circle-notch fa-spin': true,
            [styles.dlLoadingSpinnerIcon]: true,
          })}
        />
        <div className={styles.dlLoadingSpinnerText}>
          {text && <FormattedMessage id={text} defaultMessage={'Searching...'} description={'label for loading spinner'} />}
        </div>
      </div>
    </div>
  ) : null;
};

LoadingSpinner.displayName = 'LoadingSpinner';
